import { useEffect, useState, useRef } from 'react';
import { Briefcase, ArrowRight } from 'lucide-react';

export default function CareersSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="careers"
      ref={sectionRef}
      data-testid="careers-section"
      className="py-24 sm:py-32 bg-[#F4F7FD]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className={`text-center max-w-3xl mx-auto reveal ${isVisible ? 'visible' : ''}`}>
          <p className="text-[#F5A623] text-xs tracking-[0.2em] uppercase font-semibold mb-4">
            Careers
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-[#1A1A2E] mb-6">
            Build the future with us.
          </h2>
          <p className="text-lg leading-relaxed text-[#5A5A5A] mb-8">
            We're always looking for talented individuals who are passionate about technology 
            and innovation. Join our team of forward-thinking professionals building intelligent 
            software solutions.
          </p>

          <div className="glass-card-light rounded-2xl p-8 mb-8">
            <div className="flex items-center justify-center gap-4 mb-4">
              <div className="w-12 h-12 rounded-xl bg-[#193E82]/10 flex items-center justify-center">
                <Briefcase className="w-6 h-6 text-[#193E82]" />
              </div>
              <div className="text-left">
                <h3 className="text-lg font-semibold text-[#1A1A2E]">Open Positions</h3>
                <p className="text-sm text-[#5A5A5A]">We're always hiring great talent</p>
              </div>
            </div>
            <p className="text-[#5A5A5A] mb-6">
              Even if we don't have a specific opening, we'd love to hear from you. 
              Send us your CV and tell us how you can contribute to our mission.
            </p>
          </div>

          <a
            href="#contact"
            data-testid="careers-cta"
            className="btn-primary rounded-full px-8 py-4 text-base font-semibold inline-flex items-center gap-2"
          >
            Send Us Your CV
            <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
}
